import React from 'react'
import styled from '@emotion/styled'
import moment, { Moment } from 'moment'
import Datetime from 'react-datetime'
import { Button } from './Button'
import { HorizontalFlex } from './HorizontalFlex'
import { FcClock } from 'react-icons/fc'
import 'react-datetime/css/react-datetime.css'

type DateTimePickerParams = {
  innerRef: any
  dateFormat?: string
  initialValue?: string | Moment
  onChange?: (value: Moment | string) => void
}

const Content = styled.div`
  & input {
    border-width: 0px;
    border: 1px solid rgba(0, 0, 0, 0);
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 2px 2px 2px 2px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    &:focus{
      background-color: #DBD5E5;
      outline: none;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
`
export const DateTimePicker = ({ innerRef, dateFormat, initialValue, onChange }: DateTimePickerParams) => {
  function dateChanged(value: string | moment.Moment | React.FocusEvent) {
    if (onChange) {
        const eventMoment = (value instanceof moment ? value : initialValue) as moment.Moment
        eventMoment.set({ seconds: 0 })
        onChange(eventMoment)
    }
  }

  function renderView(mode: string, renderDefault: Function) {
    if (mode === 'time') {
      renderDefault()
    }

    return <div className='wrapper'>
      {renderDefault()}
      <div className='controls' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        <Button onClick={goToNow}>
          <HorizontalFlex>
            <div style={{ paddingRight: '0.5rem' }}>Now</div>
            <FcClock size={'1.5rem'} />
          </HorizontalFlex>
        </Button>
      </div>
    </div>
  }

  function goToNow() {
    const eventMoment = moment()
    eventMoment.set({ seconds: 0 })
    innerRef.current?.setState({ selectedDate: eventMoment, viewDate: eventMoment })
  }

  return <Content style={{ display: 'flex', flexDirection: 'row' }}>
    <Datetime
      ref={innerRef}
      dateFormat={dateFormat}
      initialValue={initialValue}
      onClose={e => dateChanged(e)}
      renderView={(mode, renderDefault) =>
        renderView(mode, renderDefault)
      }
    />
  </Content>
}
